// KB share-page attribution: /kb/:slug stores which page the visitor came
// from (plus their anonymous visitor id) before sending them to /register;
// AuthContext forwards it on the signup request so the backend can append a
// `registered` event and close the view→signup funnel. Mirrors referral.ts.

const REF_KEY = 'pitto_kb_landing_ref';
const VISITOR_KEY = 'pitto_kb_landing_visitor';

export interface KbLandingRef {
  slug: string;
  visitor_id: string;
}

/** Stable anonymous id for this browser, shared by the view/cta beacons and
 *  the signup attribution so the funnel can join them. */
export function landingVisitorId(): string {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

/** Remember the share page the visitor is converting from. */
export function storeLandingRef(slug: string): void {
  localStorage.setItem(REF_KEY, JSON.stringify({ slug, visitor_id: landingVisitorId() }));
}

export function storedLandingRef(): KbLandingRef | null {
  try {
    const raw = localStorage.getItem(REF_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return typeof parsed?.slug === 'string' && typeof parsed?.visitor_id === 'string' ? parsed : null;
  } catch {
    return null;
  }
}

export function clearLandingRef(): void {
  localStorage.removeItem(REF_KEY);
}
